/**
 * @param {object} state
 * @param {object} user
 */
const setUser = (state, user) => {
  state.user = user
}

/**
 * @param {object}   state
 * @param {object[]} permissions
 */
const setPermissions = (state, permissions) => {
  state.permissions = permissions
}

/**
 * @param {object} state
 * @param {number} selectedGroupId
 */
const setSelectedGroupId = (state, selectedGroupId) => {
  state.selectedGroupId = selectedGroupId
  localStorage.setItem('stitch:df:selectedGroupId', selectedGroupId)
}

/**
 * @param {object}   state
 * @param {object[]} seasons
 */
const setSeasons = (state, seasons) => {
  state.seasons = seasons
}

/**
 * @param {object} state
 * @param {number} selectedSeasonId
 */
const setSelectedSeasonId = (state, selectedSeasonId) => {
  state.selectedSeasonId = selectedSeasonId
  localStorage.setItem('stitch:df:selectedSeasonId', selectedSeasonId)
}

/**
 * @param {object}   state
 * @param {object[]} invites
 */
const setInvites = (state, invites) => {
  state.invites = invites
}

/**
 * @param {object} state
 * @param {object} invite
 */
const addInvite = (state, invite) => {
  const index = state.invites.length

  state.invites.splice(index, 1, invite)
}

/**
 * @param {object} state
 * @param {number} inviteId
 */
const deleteInvite = (state, inviteId) => {
  const index = state.invites.findIndex(invite => invite.id === inviteId)

  state.invites.splice(index, 1)
}

/**
 * @type {object}
 */
const mutations = {
  setUser,
  setPermissions,
  setSelectedGroupId,
  setSeasons,
  setSelectedSeasonId,
  setInvites,
  addInvite,
  deleteInvite
}

export default mutations
